import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import formInputsJson from "../components/formInputs.json";
import { db } from "../db";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { selectCurrency } from "../components/Redux/Slices/currencySlice";
import CategoryLists from "../components/CategoryLists";
import { Button } from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import ErrorSuccessMessage from "../components/ErrorSuccessMessage";

const AddExpenses = () => {
  const selectedCurrency = useSelector(selectCurrency);
  const navigate = useNavigate();
  const formRef = useRef(null);
  const [userAddedCategories, setUserAddedCategories] = useState([]);
  const formInputs = formInputsJson.formInputs;
  const [formData, setFormData] = useState({
    item: "",
    quantity: "1",
    category: null,
    amount: "",
    currency: selectedCurrency.code,
    date: new Date().toISOString().split("T")[0],
  });
  const [editingExpense, setEditingExpense] = useState(null);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [progress, setProgress] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [intervalId, setIntervalId] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "quantity" && value.length > 11) {
      return;
    }
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e, addAnother = false) => {
    e.preventDefault();
    if (formRef.current.checkValidity()) {
      try {
        const dateTime = new Date(formData.date.replace(/-/g, "/"));

        // const dateTime = new Date(`${formData.date} `);
        const formattedDateTime = format(dateTime, "MMMM dd, yyyy  ");
        const updatedExpense = {
          ...formData,
          dateTime: formattedDateTime,
          category: parseInt(formData.category),
          isEdited: 1,
        };

        if (editingExpense) {
          await db.expenses.update(editingExpense, updatedExpense);
          setEditingExpense(null);
        } else {
          await db.expenses.add(updatedExpense);
        }

        setFormData({
          item: "",
          quantity: "1",
          category: null,
          amount: "",
          currency: selectedCurrency.code,
          date: new Date().toISOString().split("T")[0],
        });

        if (!addAnother) {
          setMessage("Successfully Updated");
          setMessageType("success");
          startCountdown();
          setTimeout(() => {
            navigate("/");
            setMessage("");
            setMessageType("");
          }, 1000);
        } else {
          setMessage("Successfully Added");
          setMessageType("success");
        }
        if (addAnother) {
          setFormData({
            item: "",
            quantity: "1",
            category: null,
            amount: "",
            currency: selectedCurrency.code,
            date: new Date().toISOString().split("T")[0],
          });
          setMessage("Successfully Added");
          setMessageType("success");
          startCountdown();
          setTimeout(() => {
            setMessage("");
            setMessageType("");
          }, 1000);
        }
      } catch (error) {
        console.error("Error adding expense:", error);
        setMessage("Error adding expense");
        setMessageType("error");
      }
    } else {
      formRef.current.reportValidity();
    }
  };

  const handleCategoryChange = (e) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      category: value,
    }));
  };

  useEffect(() => {
    const fetchUserAddedCategories = async () => {
      try {
        const categoriesFromDB = await db.categories.toArray();
        setUserAddedCategories(categoriesFromDB);
      } catch (error) {
        console.error("Error fetching user-added categories:", error);
      }
    };

    fetchUserAddedCategories();
  }, []);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      currency: selectedCurrency.code,
    }));
  }, [selectedCurrency]);

  const startCountdown = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    setIsActive(true);
    setProgress(0);

    let currentProgress = 0;
    const newIntervalId = setInterval(() => {
      currentProgress += 100 / (1 * 10);
      setProgress(currentProgress);
    }, 100);

    setIntervalId(newIntervalId);
  };

  return (
    <>
      <div className="container  main-div ">
        <div className="display-center pb-2">
          <button
            className="btn verticalAlign position-absolute start-0 "
            onClick={() => {
              navigate(-1);
            }}
          >
            <span className="fs-1  material-symbols-outlined">
              chevron_backward
            </span>
          </button>
          <h3 className=" verticalAlign heading-txt">Add Expense</h3>
        </div>

        <div className=" card child-div  ">
          <form ref={formRef} onSubmit={handleSubmit}>
            <div className="row">
              {formInputs.map((input, index) => (
                <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-3">
                  {input.type === "select" ? (
                    <div>
                      <label className="form-label">{input.label}</label>
                      <CategoryLists
                        className="form-control"
                        categories={userAddedCategories?.filter(
                          (category) => category.isDeleted !== 1
                        )}
                        selectedParent={formData.category}
                        onChange={handleCategoryChange}
                      />
                    </div>
                  ) : (
                    <div>
                      <label className="form-label">{input.label}</label>
                      {input.name === "amount" ? (
                        <NumericFormat
                          value={formData.amount}
                          decimalScale={2}
                          onValueChange={(values) => {
                            const { value } = values;
                            setFormData((prevData) => ({
                              ...prevData,
                              amount: value,
                            }));
                          }}
                          thousandsGroupStyle="lakh"
                          thousandSeparator=","
                          prefix={selectedCurrency.label}
                          placeholder={input.placeholder}
                          className="form-control currencyIcons"
                          required={
                            input.name === "item" || input.name === "amount"
                          }
                          onKeyDown={(e) => {
                            if (e.key === "Backspace" || e.key === "Delete")
                              return;

                            const currentDigits = e.target.value.replace(
                              /\D/g,
                              ""
                            ).length;
                            if (currentDigits >= 10) {
                              e.preventDefault();
                            }
                          }}
                        />
                      ) : (
                        <input
                          type={input.type}
                          id={input.id}
                          name={input.name}
                          value={formData[input.name]}
                          onChange={
                            input.name === "category"
                              ? handleCategoryChange
                              : handleChange
                          }
                          className="form-control"
                          placeholder={input.placeholder}
                          required={
                            input.name === "item" || input.name === "amount"
                          }
                        />
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className=" display-center pt-3 pb-4 ">
              <Button
                className="me-3 btn-warning  rounded-pill noSpace"
                onClick={(e) => handleSubmit(e, true)}
              >
                <span className="material-symbols-outlined verticalAlign me-1">
                  more_time
                </span>
                <span className=" verticalAlign">Add Another</span>
              </Button>
              <Button className="save-btn rounded-pill noSpace" type="submit">
                <span className="material-symbols-outlined verticalAlign me-1">
                  save
                </span>
                <span className="verticalAlign ">Save</span>
              </Button>
            </div>
          </form>
          <ErrorSuccessMessage
            message={message}
            messageType={messageType}
            isActive={isActive}
            progress={progress}
          />
        </div>
      </div>
    </>
  );
};

export default AddExpenses;
